import { Button } from "core/components/form-controls";
import TabComponent from "core/components/Tab/TabComponent";
import { _t } from "core/language";
import {
  useCommunityFollowMain,
  useCommunityTrendMain,
  useCommunityVideoMain
} from "modules/Main/hooks";
import { memo, useState } from "react";
import PlusIcon from "../../components/icon/plus.svg";
import CommunityHeader from "./CommunityHeader";
import FollowComponent from "./FollowComponent";
import TrendingComponent from "./TrendingComponent";
import VideoComponent from "./VideoComponent";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";

const CommunityTabSection = () => {
  const navigate = useCustomNavigate();
  const [dataTrend, loadingTrend] = useCommunityTrendMain({
    tab: "trending",
  });
  const [dataFollow, loadingFollow] = useCommunityFollowMain({
    tab: "follow",
  });
  const [dataVideo, loadingVideo] = useCommunityVideoMain({
    tab: "video",
  });

  const tabs: {
    title: string;
    content: JSX.Element;
    key: "trending" | "follow" | "video";
  }[] = [
    {
      title: _t("main.community.trending"),
      content: <TrendingComponent data={dataTrend} border loading={loadingTrend} tab='trending' />,
      key: "trending",
    },
    {
      title: _t("main.community.follow"),
      content: <FollowComponent data={dataFollow} border loading={loadingFollow} tab='follow' />,
      key: "follow",
    },
    {
      title: _t("main.community.video"),
      content: <VideoComponent data={dataVideo} border loading={loadingVideo} tab='video' />,
      key: "video",
    },
  ];
  const [activeTab, setActiveTab] = useState<number>(0);
  const onClickTab = (index: number) => {
    setActiveTab(index);
    // setFilter({ tab: tabs[index].key || "trending" });
  };
  return (
    <section className="mt-2 pt-5 pb-[30px] w-full bg-white">
      <CommunityHeader />
      <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
        <TabComponent
          tabs={tabs}
          btnClass="w-full rounded-[50px] border-none py-[5px] text-[13px]"
          active={activeTab}
          activeClass="bg-[#222222] text-white"
          inActiveClass="text-[#777777] bg-[#EEEEEE]"
          handleClickTab={onClickTab}
        />
      </div>
      <div className="flex justify-center">
        <Button
          label={_t("main.community.discover_post")}
          classBtn="mt-6 !w-[calc(100%-30px)]"
          icon={<i className="fas fa-chevron-down"></i>}
          iconRight={PlusIcon}
          onClickBtn={() => {
            navigate(RouterName.COMMUNITY_LIST);
          }}
        ></Button>
      </div>
    </section>
  );
};

export default memo(CommunityTabSection);
